import { render, staticRenderFns } from "./documentDetail.vue?vue&type=template&id=7a4e57a2&scoped=true&"
import script from "./documentDetail.vue?vue&type=script&lang=js&"
export * from "./documentDetail.vue?vue&type=script&lang=js&"
import style0 from "./documentDetail.vue?vue&type=style&index=0&id=7a4e57a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4e57a2",
  null
  
)

export default component.exports